<template lang="pug">
    draggable.body(v-model="categories" tag="div" @change="updateOrder" handle=".dragger")
        .rowLine(v-for="category in categories" :key="category.uuid")
            .container
                div.small
                    .dragger
                        span
                div.categoryTitle
                    router-link.link(:to="'/admin/catalog/category/'+category.uuid")
                        span {{category.title}}
                div(:style="{width: '300px', textAlign: 'right'}")
                    va-button.ma-0(flat small color="gray" icon="fa fa-pencil" :href="'/admin/catalog/category/'+category.uuid")
                        | {{ $t('tables.edit') }}
                    va-button.ma-0(flat small color="danger" icon="fa fa-trash" @click.prevent="deleteCat(category)" v-if="!category.children")
                        | {{ $t('tables.delete') }}
            template(v-if="category.children")
                row(:categoriesProp="category.children" @reloadCategories="$emit('reloadCategories')")
            .modals
                va-modal(v-model='showModalDeleteCat' size='small' :title=" $t('catalog.categories.modal.deleteCatTitle')" :message=" $t('catalog.categories.modal.deleteCatText') " :oktext=" $t('modal.confirm') " :canceltext=" $t('modal.cancel') " @ok='deleteCategory' @cancel='abortDeleteCategory')
</template>

<script>
import row from './row.vue';
import draggable from "vuedraggable";
export default {
    name: 'row',
    props : ['categoriesProp','level'],
    components : {
        row,
        draggable
    },
    data(){
        return {
            categories: null,
            showModalDeleteCat: false,
            categoryToDelete: null,
        }
    },
    mounted(){
        this.categories = this.categoriesProp;
        if(this.categories) this.parseCategories();
    },
    methods : {
        parseCategories(){
            var arr = [];
            for(var i in this.categories){
                var obj = {};
                obj.uuid = this.categories[i].uuid;
                obj.order = parseInt(i);
                obj.title = this.categories[i].title;
                obj.children = this.categories[i].children && this.categories[i].children.length > 0 ? this.categories[i].children : null;
                arr.push(obj);
            }
            this.categories = arr;
        },
        updateOrder(movedItem){
            for(var i in this.categories){
                this.categories[i].order = i;
            }

            this.$axios.put('api/categories/updateCategoriesOrder',{categories:this.categories})
                .then(axRes => {
                    this.$emit('reloadCategories');
                    this.showToast(
                    this.$t('catalog.categories.updateCategoryOrderSuccess'),
                    {
                        icon:'fa-check',
                        position: 'bottom-right',
                        duration: 3000,
                        fullWidth: false,
                        className: 'vuestic-toast'
                    },
                    );
                }).catch(axErr => {
                    this.showToast(this.$t('system.genericError'),
                        {
                            icon:'fa-warning',
                            position: 'bottom-right',
                            duration: 10000,
                            fullWidth: false,
                            className: 'vuestic-toast error'
                        })
                    })
        },
        deleteCat(cat){
            this.showModalDeleteCat = true;
            this.categoryToDelete = cat.uuid;

        },
        deleteCategory(){
            this.$axios.delete('api/categories/deleteCategory',{data:{catUuid:this.categoryToDelete}})
            .then(axRes => {
                this.showToast(this.$t('catalog.categories.deleteCategorySuccess'),
                    {
                        icon:'fa-check',
                        position: 'bottom-right',
                        duration: 3000,
                        fullWidth: false,
                        className: 'vuestic-toast'
                    }
                );
                this.$emit("reloadCategories");
            }).catch(axErr => {
                this.showToast(this.$t('catalog.categories.deleteCategoryError'),
                    {
                        icon:'fa-warning',
                        position: 'bottom-right',
                        duration: 10000,
                        fullWidth: false,
                        className: 'vuestic-toast error'
                    }
                );
            })
        },
        abortDeleteCategory(){
            this.categoryToDelete = null;
        }
    }
}
</script>